export default __webpack_public_path__ + "img/8be57eae0b80a00c6c1fe23a00ea6846.png";